import { SimpleSpeakerAvatar } from "@/components/SpeakerAvatar";

type VirtualAgentProps = {
  name: string;
  bold?: boolean;
};

export function VirtualAgent({ name, bold = false }: VirtualAgentProps) {
  return (
    <div className="flex items-center gap-1">
      <SimpleSpeakerAvatar isVirtualAgent variant="green" />
      <span
        className={
          bold ? "text-sm font-bold text-primary" : "text-sm font-medium"
        }
      >
        {name}
      </span>
    </div>
  );
}
